import { TypedDocumentNode, gql } from '@apollo/client';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { isType, withFragments } from '@sorare/core/src/gql';
import { useSawBoxOnboarding } from '@sorare/core/src/hooks/rivals/useSawBoxOnboarding';

import { useBoxOpeningOnboardingDialog_probabilisticBundle } from './__generated__/useBoxOpeningOnboardingDialog.graphql';

export const useBoxOpeningOnboardingDialog = withFragments(
  (box: useBoxOpeningOnboardingDialog_probabilisticBundle) => {
    let onboardingDialogVariant:
      | 'limited_card'
      | 'arena_ticket'
      | 'limited_essence'
      | undefined;
    const {
      limitedCard: sawLimitedCardOnboarding,
      arenaTickets: sawArenaTicketsOnboarding,
      essence: sawEssenceOnboarding,
    } = useSawBoxOnboarding();

    const slotItem = box.items.at(0);
    if (
      isType(slotItem, 'ProbabilisticBundleSlotCardItem') &&
      slotItem.anyCard?.rarityTyped === Rarity.limited &&
      !sawLimitedCardOnboarding
    ) {
      onboardingDialogVariant = 'limited_card';
    } else if (
      isType(slotItem, 'ProbabilisticBundleSlotArenaTicketItem') &&
      !sawArenaTicketsOnboarding
    ) {
      onboardingDialogVariant = 'arena_ticket';
    } else if (
      isType(slotItem, 'ProbabilisticBundleSlotCardShardItem') &&
      !sawEssenceOnboarding
    ) {
      onboardingDialogVariant = 'limited_essence';
    }
    return onboardingDialogVariant;
  },
  {
    probabilisticBundle: gql`
      fragment useBoxOpeningOnboardingDialog_probabilisticBundle on ProbabilisticBundle {
        id
        items {
          id
          ... on ProbabilisticBundleSlotCardItem {
            id
            anyCard {
              slug
              rarityTyped
            }
          }
          ... on ProbabilisticBundleSlotArenaTicketItem {
            id
          }
          ... on ProbabilisticBundleSlotCardShardItem {
            id
          }
        }
      }
    ` as TypedDocumentNode<useBoxOpeningOnboardingDialog_probabilisticBundle>,
  }
);
